import React from 'react'

import Base from '../../_Base'

const Facebook16 = (props) => (
  <Base
    aria-hidden="true"
    focusable="false"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      d="M15.117 0H.883A.883.883 0 0 0 0 .883v14.234c0 .488.395.883.883.883h7.663V9.804H6.46V7.389h2.085V5.608c0-2.066 1.262-3.191 3.106-3.191.883 0 1.642.065 1.863.095v2.159l-1.278.001c-1.003 0-1.197.476-1.197 1.176v1.541h2.39l-.31 2.415h-2.08V16h4.077a.883.883 0 0 0 .883-.883V.883A.883.883 0 0 0 15.117 0"
      fillRule="evenodd"
    />
  </Base>
)

export default Facebook16
